function sponsors_Reducer(state = [], action) {
    switch (action.type) {
        case 'SPONSORS/SET':
            return action.sponsors;
        case 'SPONSORS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default sponsors_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/sponsors.js